const setting = {
  passwordTitle: "パスワード",
  changePasswordBtn: "パスワードを変換する",
  changePasswordTips:
    "パスワードを忘れた場合、またはパスワードを変更したい場合は、ここで変更できます。登録したメールアドレスに確認コードを送信します。本人確認をすれば、パスワードをリセットできます。",
  feedbackTitle: "フィードバック",
  feedbackBtn: "フィードバックを送信する",
  feedbackTips:
    "より良いサービスを提供するために、できるだけ詳しく説明をして、フィードバックを送信してください。確認出来次第、カスタマーサービスチームから迅速にご連絡いたします。",
  appearanceTitle: "ディスプレイ表示",
  appearanceBtn: "ディスプレイ変更",
  appearanceTips: "2つの外観モードを提供します。好みに応じて暗いモードと明るいモードを切り替えることができます。",
  changePassWordModalTitle: "パスワードを変換する",
  changePassWordSameErrorTips: "入力した新しいパスワードは、現在のパスワードと同じです。別のパスワードを入力してください",
  changePasswordCurrentErrorTips: "パスワードが間違っていました。もう一度やり直してください。",
  currentPasswordLabel: "現在のパスワード",
  newPasswordLabel: "新しいパスワード",
  retypePasswordLabel: "新しいパスワードを再入力する",
  changePasswordSuccessTips: "パスワードは既に再設定しました。",
  changePasswordComfirmDiffErrorTips: "両方のフィールドに同じパスワードを入力してください。",
  forgotPassword: "パスワードが忘れた場合",
  feedbackModalSubtitle: "フィードバックを頂きまして、誠にありがとうございます。",
  feedBackModalProductQuestion: "当社の製品でどのような問題を解決したいですか?",
  feedBackModalProductTypeSug: "提案",
  feedBackModalProductTypeMem: "会員サービスに関する質問",
  feedBackModalProductTypeFun: "機能に関する質問",
  feedBackModalProductTypeReq: "製品要件",
  feedBackModalProductTypeBug: "製品バグをフィードバックする",
  feedBackModalProductTypeIss: "パフォーマンスに関する質問",
  feedBackModalProductTypeRL: "登録、ログインに関する質問",
  feedBackModalProductTypeRef: "返金サービス",
  feedBackModalProductTypeOth: "その他",
  feedBackModalProductSelectQuestion: "当社の製品でどのような問題を解決したいですか?",
  feedBackModalProductContQuestion: "製品をご使用いただく中、何か不具合が起きていますか。",
  feedBackModalAddImageBtn: "画像を添付する",
  feedBackModalTips: "ヒント:",
  feedBackModalTipsCont: "世界的なカスタマーサービスの時差のため、営業日の48時間以内に返信します。",
  feedBackSuccessTips: "送信に成功しました",
  feedBackSuccessSubTips: "確認出来次第、迅速に対応させていただきます。",
  feedBackFailedTips: "送信に失敗しました",
  feedBackFailedSubTips: "ネットワーク接続が機能していることを確認し、再度送信してください。",
  appearanceLightMode: "ライトモード",
  appearanceDarkMode: "ダークモード",
  promotionModalTitle: "プロモーション",
  promoItem: "販促品",
  promoCode: "販促コード",
  discount: "割引",
  applyBtn: "適用する",
  applyPromotionErrorTips: "販促コードが無限になりました。",
};

export default setting;
